import React from 'react'
import {useNavigate} from 'react-router-dom'
import Button from '@material-ui/core/Button'
import Avatar from '@material-ui/core/Avatar'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Auth from 'lib/auth'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import {faSignOutAlt, faSlidersH, faCaretDown} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {makeStyles} from '@material-ui/core'

const profileMenu = 'profile-menu'
const useStyles = makeStyles(() => ({
  root: {
    height: '64px',
    display: 'flex',

    '& .MuiButtonBase-root:hover': {
      borderRadius: 0,
    },
  },
}))

function AppBarProfileNavItem() {
  const classes = useStyles()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const {user, signOut} = useAuthentication()

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  async function handleLogout() {
    signOut()
    await Auth.signOut()
  }

  function handleSettings() {
    navigate('/me/settings')
    handleClose()
  }

  function handleClose() {
    setAnchorEl(null)
  }

  return <div className={classes.root}>
    <Button aria-controls={profileMenu} aria-haspopup="true" onClick={handleClick}>
      <Avatar>{user.username.substr(0, 1)}</Avatar>
      <FontAwesomeIcon icon={faCaretDown} size="lg" style={{marginLeft: '2px'}}/>
    </Button>
    <Menu
      id={profileMenu}
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <MenuItem onClick={handleSettings}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faSlidersH} size="lg"/>
        </ListItemIcon>
        Settings
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faSignOutAlt} size="lg"/>
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  </div>
}


export default AppBarProfileNavItem
